import { useCallback } from 'react';

import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';
import { useImageUploadContext } from 'src/app/shared/hooks/imageUpload';
import { useCurrentUser } from 'src/app/shared/hooks/session';

import { usePreviewModal } from '../../components/PreviewModal/hooks/usePreviewModal';
import type { PetitionUpdateFormValues } from '../../types';

export function useOpenPreviewModal() {
	const openModal = usePreviewModal();
	const currentUser = useCurrentUser();
	const {
		data: {
			petition: { displayTitle },
		},
	} = useStarterDashboardV2PageData();
	const { state } = useImageUploadContext();

	return useCallback(
		async (values: PetitionUpdateFormValues) => {
			await openModal({
				emailTitle: values.title || '',
				emailContent: values.description || '',
				userName: currentUser?.displayName || '',
				petitionTitle: displayTitle,
				imageDataUrl: typeof state.cropper !== 'undefined' ? state.cropper.getCroppedCanvas().toDataURL() : undefined,
			}).waitForClosed();
		},
		[openModal, state.cropper, currentUser, displayTitle],
	);
}
